import { render, staticRenderFns } from "./company-block.vue?vue&type=template&id=347bd8b7"
import script from "./company-block.vue?vue&type=script&lang=js"
export * from "./company-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports